import React, { useEffect, useState } from "react";
import AdminNavbar from "../Layout/AdminNavbar";
import axios from "axios";
import { toast } from "react-toastify";
import API_BASE_URL from "../config";
import { useNavigate } from "react-router-dom";

const EmployeeEvaluation = () => {

    const token = localStorage.getItem("token");
    const navigate = useNavigate();

    const [evaluations, setEvaluations] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showEvaluationModal, setShowEvaluationModal] = useState(false);
    const [evaluationData, setEvaluationData] = useState(null);
    const [selectedMonth, setSelectedMonth] = useState("");

    // ================= LOAD DATA =================
    const fetchEvaluations = async () => {
        try {
            const res = await axios.get(`${API_BASE_URL}/api/evaluations`, {
                headers: { Authorization: `Bearer ${token}` }
            });

            setEvaluations(res.data);
        } catch (err) {
            console.error(err);
            toast.error("Failed to load evaluations");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchEvaluations();
    }, []);

    // ================= DELETE =================
    const handleDelete = async (id) => {
        if (!window.confirm("Delete this evaluation?")) return;

        try {
            await axios.delete(`${API_BASE_URL}/api/evaluations/${id}`, {
                headers: { Authorization: `Bearer ${token}` }
            });

            toast.success("Deleted successfully");

            // refresh list
            fetchEvaluations();

        } catch (err) {
            console.error(err);
            toast.error("Delete failed");
        }
    };


    const handleSubmitEvaluation = async () => {
        try {
            const payload = {
                employeeId: evaluationData.employeeId,
                managerId: evaluationData.managerId,

                employeeType: evaluationData.employeeType,
                month: evaluationData.month,
                week: evaluationData.week,

                assignedTasks: evaluationData.assignedTasks,
                completedTasks: evaluationData.completedTasks,
                billingHours: evaluationData.billingHours,

                taskCompletion: evaluationData.ratings.taskCompletion,
                quality: evaluationData.ratings.quality,
                teamwork: evaluationData.ratings.teamwork,
                initiative: evaluationData.ratings.initiative,
                learning: evaluationData.ratings.learning,

                remarks: evaluationData.remarks
            };

            await axios.put(
                `${API_BASE_URL}/api/evaluations/${evaluationData.id}`,
                payload,
                {
                    headers: { Authorization: `Bearer ${token}` }
                }
            );

            toast.success("Evaluation updated successfully!");

            setShowEvaluationModal(false);
            fetchEvaluations();

        } catch (err) {
            console.error(err);
            toast.error("Update failed");
        }
    };

    // ================= EDIT =================
    const handleEdit = (e) => {
        setEvaluationData({
            ...e,
            ratings: {
                taskCompletion: e.taskCompletion,
                quality: e.quality,
                teamwork: e.teamwork,
                initiative: e.initiative,
                learning: e.learning
            }
        });

        setShowEvaluationModal(true);
    };

    useEffect(() => {
        const now = new Date();
        const monthName = now.toLocaleString("default", { month: "long" });
        const year = now.getFullYear();

        setSelectedMonth(`${monthName} ${year}`);
    }, []);

    useEffect(() => {
        if (!evaluationData) return;

        const values = Object.values(evaluationData.ratings || {})
            .filter(v => v > 0);

        if (!values.length) return;

        const avg = values.reduce((a, b) => a + b, 0) / values.length;

        let grade = "D";
        if (avg >= 4.5) grade = "A+";
        else if (avg >= 4) grade = "A";
        else if (avg >= 3.5) grade = "B+";
        else if (avg >= 3) grade = "B";
        else if (avg >= 2) grade = "C";

        setEvaluationData(prev => ({
            ...prev,
            finalScore: avg.toFixed(2),
            grade
        }));

    }, [evaluationData?.ratings]);

    const filteredEvaluations = selectedMonth
        ? evaluations.filter(e => e.month === selectedMonth)
        : evaluations;

    return (
        <>

            <div className="fixed-top">
                <AdminNavbar />
            </div>

            <div className="container-fluid px-4" style={{ paddingTop: "120px" }}>

                <div className="card shadow-sm border-0">

                    <div className="card-header d-flex justify-content-between align-items-center">
                        <h5 className="mb-0">Employee Evaluations</h5>

                        <div className="d-flex gap-2 align-items-center">

                            <select
                                className="form-select form-select-sm"
                                style={{ width: "180px" }}
                                value={selectedMonth}
                                onChange={(e) => setSelectedMonth(e.target.value)}
                            >
                                <option value="">All Months</option>

                                {[...new Set(evaluations.map(e => e.month))].map((month, i) => (
                                    <option key={i} value={month}>
                                        {month}
                                    </option>
                                ))}

                            </select>

                        </div>

                        {/* <button
                            className="btn btn-primary btn-sm"
                            onClick={() => navigate("/admin/evaluation")}
                        >
                            + Add Evaluation
                        </button> */}
                    </div>

                    <div className="card-body p-0">

                        {loading ? (
                            <div className="p-4 text-center">Loading...</div>
                        ) : (
                            <div className="table-responsive">
                                <table className="table table-bordered mb-0 text-center">

                                    <thead className="table-light">
                                        <tr>
                                            <th>Sr No</th>
                                            <th>Employee</th>
                                            <th>Manager</th>
                                            <th>Type</th>
                                            <th>Month</th>
                                            <th>Week</th>
                                            <th>Tasks</th>
                                            <th>Hours</th>
                                            <th>TC</th>
                                            <th>Quality</th>
                                            <th>Teamwork</th>
                                            <th>Initiative</th>
                                            <th>Learning</th>
                                            <th>Score</th>
                                            <th>Grade</th>
                                            <th>Remarks</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {filteredEvaluations.length ? (
                                            filteredEvaluations.map((e, index) => (
                                                <tr key={e.id}>
                                                    <td>{index + 1}</td>

                                                    <td>{e.employeeName || e.employeeId}</td>
                                                    <td>{e.managerName || e.managerId}</td>

                                                    <td>{e.employeeType}</td>
                                                    <td>{e.month}</td>
                                                    <td>{e.week}</td>

                                                    <td>{e.completedTasks}/{e.assignedTasks}</td>
                                                    <td>{e.billingHours}</td>

                                                    {/* ✅ Numeric Ratings */}
                                                    <td className="fw-semibold">{e.taskCompletion}</td>
                                                    <td className="fw-semibold">{e.quality}</td>
                                                    <td className="fw-semibold">{e.teamwork}</td>
                                                    <td className="fw-semibold">{e.initiative}</td>
                                                    <td className="fw-semibold">{e.learning}</td>

                                                    <td>{e.finalScore}</td>

                                                    <td>
                                                        <span className={`badge ${e.grade?.startsWith("A") ? "bg-success" :
                                                            e.grade?.startsWith("B") ? "bg-primary" :
                                                                e.grade?.startsWith("C") ? "bg-warning" :
                                                                    "bg-danger"
                                                            }`}>
                                                            {e.grade}
                                                        </span>
                                                    </td>

                                                    <td style={{ maxWidth: "160px" }}>
                                                        <span
                                                            className="text-truncate d-inline-block"
                                                            style={{ maxWidth: "150px", cursor: "pointer" }}
                                                            title={e.remarks}
                                                        >
                                                            {e.remarks}
                                                        </span>
                                                    </td>

                                                    <td>
                                                        <div className="d-flex justify-content-center gap-2">
                                                            <button
                                                                className="btn btn-sm btn-warning"
                                                                onClick={() => handleEdit(e)}
                                                            >
                                                                Edit
                                                            </button>

                                                            <button
                                                                className="btn btn-sm btn-danger"
                                                                onClick={() => handleDelete(e.id)}
                                                            >
                                                                Delete
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="17">No evaluations found</td>
                                            </tr>
                                        )}
                                    </tbody>

                                </table>
                            </div>
                        )}

                    </div>

                </div>

            </div>

            {showEvaluationModal && evaluationData && (
                <div
                    className="modal fade show d-block"
                    tabIndex="-1"
                    style={{
                        background: "rgba(0,0,0,0.4)",
                        backdropFilter: "blur(4px)"
                    }}
                >
                    <div className="modal-dialog modal-xl modal-dialog-centered">
                        <div className="modal-content border-0 shadow-lg rounded-4">

                            {/* HEADER */}
                            <div className="modal-header border-0">
                                <h5 className="modal-title fw-bold">Employee Evaluation</h5>
                                <button
                                    className="btn-close"
                                    onClick={() => setShowEvaluationModal(false)}
                                ></button>
                            </div>

                            {/* BODY */}
                            <div className="modal-body p-4">

                                <div className="row g-4">

                                    {/* LEFT SIDE */}
                                    <div className="col-lg-6">

                                        {/* EMPLOYEE DETAILS */}
                                        <div className="card border-0 shadow-sm mb-4">
                                            <div className="card-body">
                                                <h6 className="fw-bold text-primary mb-3">👤 Employee Details</h6>

                                                <div className="row g-3">

                                                    <div className="col-12">
                                                        <label className="small text-muted">Manager</label>
                                                        <input
                                                            className="form-control bg-light"
                                                            value={evaluationData.managerName || evaluationData.managerId || ""}
                                                            readOnly
                                                        />
                                                    </div>

                                                    <div className="col-12">
                                                        <label className="small text-muted">Employee</label>
                                                        <input
                                                            className="form-control bg-light"
                                                            value={evaluationData.employeeName || evaluationData.employeeId || ""}
                                                            readOnly
                                                        />
                                                    </div>

                                                    <div className="col-12">
                                                        <label className="small text-muted">Employee Type</label>
                                                        <select
                                                            className="form-select"
                                                            value={evaluationData.employeeType || ""}
                                                            onChange={(e) =>
                                                                setEvaluationData(prev => ({
                                                                    ...prev,
                                                                    employeeType: e.target.value
                                                                }))
                                                            }
                                                        >
                                                            <option value="">Select</option>
                                                            <option>Full-Time</option>
                                                            <option>Intern</option>
                                                            <option>Trainee</option>
                                                        </select>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>

                                        {/* WORK SUMMARY */}
                                        <div className="card border-0 shadow-sm">
                                            <div className="card-body">
                                                <h6 className="fw-bold text-success mb-3">📊 Work Summary</h6>

                                                <div className="row g-3">

                                                    {[
                                                        { label: "Month", key: "month" },
                                                        { label: "Week", key: "week" },
                                                        { label: "Assigned Tasks", key: "assignedTasks" },
                                                        { label: "Completed Tasks", key: "completedTasks" },
                                                        { label: "Billing Hours", key: "billingHours" }
                                                    ].map((item, i) => (
                                                        <div key={i} className="col-6">
                                                            <label className="small text-muted">{item.label}</label>
                                                            <input
                                                                className="form-control"
                                                                value={evaluationData[item.key] || ""}
                                                                onChange={(e) =>
                                                                    setEvaluationData(prev => ({
                                                                        ...prev,
                                                                        [item.key]:
                                                                            item.key === "assignedTasks" ||
                                                                                item.key === "completedTasks" ||
                                                                                item.key === "billingHours"
                                                                                ? Number(e.target.value)
                                                                                : e.target.value
                                                                    }))
                                                                }
                                                            />
                                                        </div>
                                                    ))}

                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                    {/* RIGHT SIDE */}
                                    <div className="col-lg-6">

                                        {/* RATINGS */}
                                        <div className="card border-0 shadow-sm mb-4">
                                            <div className="card-body">
                                                <h6 className="fw-bold text-warning mb-3">⭐ Performance Ratings</h6>

                                                {[
                                                    { label: "Task Completion", key: "taskCompletion" },
                                                    { label: "Quality Of Task", key: "quality" },
                                                    { label: "Team Work", key: "teamwork" },
                                                    { label: "Initiative", key: "initiative" },
                                                    { label: "Learning", key: "learning" }
                                                ].map((item, idx) => (
                                                    <div
                                                        key={idx}
                                                        className="d-flex justify-content-between align-items-center mb-3 p-2 rounded"
                                                        style={{ background: "#f8f9fa" }}
                                                    >
                                                        <span className="fw-semibold">{item.label}</span>

                                                        <div>
                                                            {[1, 2, 3, 4, 5].map((star) => (
                                                                <i
                                                                    key={star}
                                                                    className={`bi ${star <= (evaluationData.ratings?.[item.key] || 0)
                                                                        ? "bi-star-fill text-warning"
                                                                        : "bi-star text-secondary"
                                                                        } fs-4 me-1`}
                                                                    style={{ cursor: "pointer" }}
                                                                    onClick={() =>
                                                                        setEvaluationData(prev => ({
                                                                            ...prev,
                                                                            ratings: {
                                                                                ...prev.ratings,
                                                                                [item.key]: star
                                                                            }
                                                                        }))
                                                                    }
                                                                ></i>
                                                            ))}
                                                        </div>
                                                    </div>
                                                ))}

                                            </div>
                                        </div>

                                        {/* PERFORMANCE */}
                                        <div className="card border-0 shadow-sm">
                                            <div className="card-body text-center">

                                                <h6 className="fw-bold text-info mb-2">📈 Overall Performance</h6>

                                                <h1 className="fw-bold text-success">
                                                    {evaluationData.finalScore || 0}
                                                    <span className="fs-6 text-muted"> / 5</span>
                                                </h1>

                                                <div className="progress mt-3 mb-3" style={{ height: "10px" }}>
                                                    <div
                                                        className="progress-bar bg-success"
                                                        style={{
                                                            width: `${((evaluationData.finalScore || 0) / 5) * 100}%`
                                                        }}
                                                    ></div>
                                                </div>

                                                <span className={`badge px-4 py-2 fs-6 ${evaluationData.grade?.startsWith("A")
                                                    ? "bg-success"
                                                    : evaluationData.grade?.startsWith("B")
                                                        ? "bg-primary"
                                                        : evaluationData.grade?.startsWith("C")
                                                            ? "bg-warning"
                                                            : "bg-danger"
                                                    }`}>
                                                    Grade: {evaluationData.grade || "-"}
                                                </span>

                                            </div>
                                        </div>

                                    </div>

                                    {/* REMARKS */}
                                    <div className="col-12">
                                        <div className="card border-0 shadow-sm">
                                            <div className="card-body">
                                                <h6 className="fw-bold text-danger mb-2">📝 Remarks</h6>
                                                <textarea
                                                    className="form-control"
                                                    rows="3"
                                                    placeholder="Write feedback..."
                                                    value={evaluationData.remarks || ""}
                                                    onChange={(e) =>
                                                        setEvaluationData(prev => ({
                                                            ...prev,
                                                            remarks: e.target.value
                                                        }))
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>

                            {/* FOOTER */}
                            <div className="modal-footer border-0">
                                <button
                                    className="btn btn-success px-4"
                                    onClick={handleSubmitEvaluation}
                                >
                                    Update
                                </button>

                                <button
                                    className="btn btn-light px-4"
                                    onClick={() => setShowEvaluationModal(false)}
                                >
                                    Cancel
                                </button>
                            </div>

                        </div>
                    </div>
                </div>
            )}

        </>
    );
};

export default EmployeeEvaluation;